// components/apply/ApplyPage.tsx
import React, { useMemo, useState } from 'react';
import { API_BASE } from '../../config/api.ts';

const SUBMIT_ENDPOINT = `${API_BASE}/public/social-media-application`;

const LOGO = `${process.env.PUBLIC_URL}/logo192.jpeg`;

/* Official brand marks (24x24 viewBox) */
const BRAND_PATHS = {
  instagram: 'M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077',
  tiktok: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  snapchat: 'M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.918-.222-2.95-.642-3.189-1.226-.031-.063-.052-.15-.055-.225-.015-.243.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.029-.24-.074-.346-.119-1.107-.435-1.257-.93-1.197-1.273.09-.479.674-.793 1.168-.793.146 0 .27.029.383.074.42.194.789.3 1.104.3.234 0 .384-.06.465-.105l-.046-.569c-.098-1.626-.225-3.651.307-4.837C7.392 1.077 10.739.807 11.727.807l.419-.015h.06z',
  x: 'M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z'
};

const PLATFORMS = [
  { id: 'instagram', name: 'Instagram', tile: 'bg-gradient-to-tr from-[#feda75] via-[#d62976] to-[#4f5bd5]', icon: 'text-white' },
  { id: 'tiktok', name: 'TikTok', tile: 'bg-black', icon: 'text-white' },
  { id: 'snapchat', name: 'Snapchat', tile: 'bg-[#FFFC00]', icon: 'text-white drop-shadow-sm' },
  { id: 'x', name: 'X', tile: 'bg-black', icon: 'text-white' }
] as const;

const YEARS_OPTIONS = [
  { value: 'less_than_1', label: 'أقل من سنة' },
  { value: '1_2', label: 'من سنة إلى سنتين' },
  { value: '2_3', label: 'من سنتين إلى 3 سنوات' },
  { value: '3_5', label: 'من 3 إلى 5 سنوات' },
  { value: 'more_than_5', label: 'أكثر من 5 سنوات' }
];

const AVAILABILITY_OPTIONS = [
  { value: 'immediately', label: 'فوراً' },
  { value: 'within_week', label: 'خلال أسبوع' },
  { value: 'within_two_weeks', label: 'خلال أسبوعين' },
  { value: 'within_month', label: 'خلال شهر' },
  { value: 'specific_date', label: 'تاريخ محدد' }
];

/**
 * Same shape the rest of the app uses for phone entry (see AuthStep), so the
 * country code is picked, never typed — applicants were unsure whether to
 * write +965 themselves.
 */
const COUNTRIES = [
  { code: '+965', name: 'الكويت', flag: '🇰🇼', placeholder: '51234567' },
  { code: '+966', name: 'السعودية', flag: '🇸🇦', placeholder: '512345678' },
  { code: '+971', name: 'الإمارات', flag: '🇦🇪', placeholder: '501234567' },
  { code: '+974', name: 'قطر', flag: '🇶🇦', placeholder: '33123456' },
  { code: '+973', name: 'البحرين', flag: '🇧🇭', placeholder: '36123456' },
  { code: '+968', name: 'عُمان', flag: '🇴🇲', placeholder: '91234567' },
  { code: '+20', name: 'مصر', flag: '🇪🇬', placeholder: '1012345678' },
  { code: '+962', name: 'الأردن', flag: '🇯🇴', placeholder: '791234567' },
  { code: '+961', name: 'لبنان', flag: '🇱🇧', placeholder: '71123456' },
  { code: '+963', name: 'سوريا', flag: '🇸🇾', placeholder: '944123456' },
  { code: '+964', name: 'العراق', flag: '🇮🇶', placeholder: '7712345678' },
  { code: '+967', name: 'اليمن', flag: '🇾🇪', placeholder: '712345678' }
];

interface ApplicationForm {
  full_name: string;
  country_code: string;
  /** Local part only — the country code lives in country_code. */
  phone: string;
  email: string;
  location: string;
  has_experience: 'yes' | 'no' | '';
  years_experience: string;
  account_links: string[];
  platforms: string[];
  availability: string;
  start_date: string;
}

const INITIAL_FORM: ApplicationForm = {
  full_name: '',
  country_code: COUNTRIES[0].code,
  phone: '',
  email: '',
  location: '',
  has_experience: '',
  years_experience: '',
  account_links: ['', '', ''],
  platforms: [],
  availability: '',
  start_date: ''
};

type FormErrors = Partial<Record<keyof ApplicationForm, string>>;

/* ---------------------------------- UI bits --------------------------------- */

const SectionCard: React.FC<{
  number: number;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}> = ({ number, title, subtitle, children }) => (
  <section className="bg-white rounded-2xl border border-gray-100 shadow-sm shadow-gray-200/60 overflow-hidden">
    <div className="flex items-center gap-3 px-5 sm:px-7 py-4 border-b border-gray-100 bg-gray-50/70">
      <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-teal-500 text-white flex items-center justify-center font-bold text-sm">
        {number}
      </div>
      <div>
        <h2 className="text-base sm:text-lg font-bold text-gray-900 leading-tight">{title}</h2>
        {subtitle && <p className="text-xs sm:text-sm text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
    </div>
    <div className="p-5 sm:p-7 space-y-5">{children}</div>
  </section>
);

const Field: React.FC<{
  label: string;
  htmlFor?: string;
  required?: boolean;
  optional?: boolean;
  error?: string;
  hint?: string;
  children: React.ReactNode;
}> = ({ label, htmlFor, required, optional, error, hint, children }) => (
  <div className="space-y-1.5">
    <label htmlFor={htmlFor} className="flex items-center gap-2 text-sm font-semibold text-gray-800">
      <span>{label}</span>
      {required && <span className="text-red-500">*</span>}
      {optional && (
        <span className="text-[11px] font-normal text-gray-400 bg-gray-100 rounded-full px-2 py-0.5">
          اختياري
        </span>
      )}
    </label>
    {children}
    {hint && !error && <p className="text-xs text-gray-400">{hint}</p>}
    {error && (
      <p className="flex items-center gap-1 text-xs font-medium text-red-600">
        <svg className="w-3.5 h-3.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 9a1 1 0 012 0v4a1 1 0 11-2 0V9zm1-4a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
        </svg>
        {error}
      </p>
    )}
  </div>
);

/** Shared control styling — no width, so callers stay in charge of sizing. */
const controlClasses = (hasError?: boolean) => `
  px-4 py-3 rounded-xl bg-white text-gray-900 placeholder-gray-400
  border transition-all duration-200 outline-none text-right
  ${hasError
    ? 'border-red-300 focus:border-red-400 focus:ring-4 focus:ring-red-100'
    : 'border-gray-200 hover:border-gray-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100'}
`;

const inputClasses = (hasError?: boolean) => `w-full ${controlClasses(hasError)}`;

/** Native select + a visible chevron, so it reads as a dropdown in RTL. */
const SelectControl: React.FC<
  React.SelectHTMLAttributes<HTMLSelectElement> & { hasError?: boolean; wrapperClassName?: string }
> = ({ hasError, wrapperClassName = 'w-full', className = '', children, ...props }) => (
  <div className={`relative ${wrapperClassName}`}>
    <select
      {...props}
      className={`w-full appearance-none cursor-pointer pl-10 ${controlClasses(hasError)} ${className}`}
    >
      {children}
    </select>
    <svg
      className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </div>
);

/* ---------------------------------- Page ----------------------------------- */

export const ApplyPage: React.FC = () => {
  const [form, setForm] = useState<ApplicationForm>(INITIAL_FORM);
  const [errors, setErrors] = useState<FormErrors>({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [serverErrorList, setServerErrorList] = useState<string[]>([]);

  const selectedCountry = COUNTRIES.find(c => c.code === form.country_code) ?? COUNTRIES[0];

  const update = <K extends keyof ApplicationForm>(key: K, value: ApplicationForm[K]) => {
    setForm(prev => ({ ...prev, [key]: value }));
    setErrors(prev => (prev[key] ? { ...prev, [key]: undefined } : prev));
  };

  const togglePlatform = (id: string) => {
    setForm(prev => ({
      ...prev,
      platforms: prev.platforms.includes(id)
        ? prev.platforms.filter(p => p !== id)
        : [...prev.platforms, id]
    }));
    setErrors(prev => (prev.platforms ? { ...prev, platforms: undefined } : prev));
  };

  const updateLink = (index: number, value: string) => {
    setForm(prev => {
      const links = [...prev.account_links];
      links[index] = value;
      return { ...prev, account_links: links };
    });
  };

  // Simple completion meter for the required fields
  const progress = useMemo(() => {
    const checks = [
      form.full_name.trim().length > 1,
      form.phone.length >= 6,
      form.email.includes('@'),
      form.location.trim().length > 1,
      form.has_experience !== '',
      form.has_experience === 'no' || form.years_experience !== '',
      form.platforms.length > 0,
      form.availability !== ''
    ];
    return Math.round((checks.filter(Boolean).length / checks.length) * 100);
  }, [form]);

  /**
   * Runs after the error state has painted, so the wrapper that just gained
   * data-error="true" is actually in the DOM to scroll to.
   */
  const scrollToFirstError = () => {
    setTimeout(() => {
      const target = document.querySelector('[data-error="true"]');
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  };

  const validate = (): boolean => {
    const next: FormErrors = {};

    if (form.full_name.trim().length < 3) next.full_name = 'يرجى إدخال الاسم الكامل';

    if (form.phone.length < 6) next.phone = 'يرجى إدخال رقم هاتف صحيح بدون رمز الدولة';

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) next.email = 'يرجى إدخال بريد إلكتروني صحيح';

    if (form.location.trim().length < 2) next.location = 'يرجى إدخال المدينة والدولة';

    if (!form.has_experience) next.has_experience = 'يرجى اختيار نعم أو لا';

    if (form.has_experience === 'yes' && !form.years_experience) {
      next.years_experience = 'يرجى تحديد سنوات الخبرة';
    }

    if (form.platforms.length === 0) next.platforms = 'يرجى اختيار منصة واحدة على الأقل';

    if (!form.availability) next.availability = 'يرجى تحديد موعد البدء';
    if (form.availability === 'specific_date' && !form.start_date) next.start_date = 'يرجى اختيار التاريخ';

    setErrors(next);

    if (Object.keys(next).length > 0) {
      scrollToFirstError();
      return false;
    }
    return true;
  };

  /**
   * Turns a Laravel error bag into per-field messages. Keys arrive as
   * "phone" or "account_links.0"; both belong to the same field on screen.
   */
  const applyServerErrors = (serverErrors: Record<string, string[] | string>): string[] => {
    const next: FormErrors = {};
    const messages: string[] = [];

    Object.entries(serverErrors).forEach(([key, value]) => {
      const message = Array.isArray(value) ? value[0] : String(value);
      const field = key.split('.')[0] as keyof ApplicationForm;

      messages.push(message);
      if (!next[field]) next[field] = message;
    });

    setErrors(next);
    return messages;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitError('');
    setServerErrorList([]);

    if (!validate()) return;

    const payload = {
      ...form,
      phone: `${form.country_code}${form.phone}`,
      years_experience: form.has_experience === 'no' ? null : form.years_experience,
      account_links: form.account_links.map(l => l.trim()).filter(Boolean),
      start_date: form.availability === 'specific_date' ? form.start_date : null
    };

    setSubmitting(true);
    try {
      const response = await fetch(SUBMIT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();

      if (response.ok && data.success !== false) {
        setSubmitted(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        setSubmitError(data.message || 'تعذر إرسال الطلب. يرجى المحاولة مرة أخرى.');

        // 422: show exactly which answer the server rejected, next to it.
        if (data.errors) {
          setServerErrorList(applyServerErrors(data.errors));
          scrollToFirstError();
        }
      }
    } catch (err) {
      setSubmitError('حدث خطأ في الاتصال. يرجى المحاولة مرة أخرى.');
    } finally {
      setSubmitting(false);
    }
  };

  /* ------------------------------ Success screen ----------------------------- */

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-lg text-center animate-fadeIn">
          <img src={LOGO} alt="Kuwait Best Solver" className="h-14 w-auto object-contain mx-auto mb-8" />
          <div className="mx-auto w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-6">
            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3">تم استلام طلبك بنجاح</h1>
          <p className="text-gray-600 leading-relaxed mb-8">
            شكراً لك {form.full_name.split(' ')[0]}، وصلنا طلب التقديم الخاص بك.
            سيقوم فريق Kuwait Best Solver بمراجعة الطلب والتواصل معك عبر البريد الإلكتروني أو رقم الهاتف.
          </p>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 text-right space-y-3 mb-8">
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-500">الاسم</span>
              <span className="font-semibold text-gray-900">{form.full_name}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-500">البريد الإلكتروني</span>
              <span className="font-semibold text-gray-900 truncate max-w-[60%]" dir="ltr">{form.email}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-500">رقم الهاتف</span>
              <span className="font-semibold text-gray-900" dir="ltr">{form.country_code} {form.phone}</span>
            </div>
          </div>
          <button
            type="button"
            onClick={() => {
              setForm(INITIAL_FORM);
              setSubmitted(false);
            }}
            className="text-blue-600 hover:text-blue-700 font-semibold text-sm"
          >
            تقديم طلب آخر
          </button>
        </div>
      </div>
    );
  }

  /* --------------------------------- Form ---------------------------------- */

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <header className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900">
        <div className="absolute -top-24 -right-24 w-80 h-80 bg-blue-500/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-32 -left-16 w-80 h-80 bg-teal-400/20 rounded-full blur-3xl" />

        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 pt-10 pb-16 sm:pt-14 sm:pb-24">
          <div className="flex items-center mb-10">
            <div className="bg-white rounded-2xl px-4 py-2.5 shadow-lg shadow-black/20">
              <img
                src={LOGO}
                alt="Kuwait Best Solver"
                className="h-14 w-auto object-contain"
              />
            </div>
          </div>

          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/15 text-teal-300 text-xs font-semibold mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-teal-400 animate-pulse" />
            التقديم مفتوح الآن
          </span>

          <h1 className="text-3xl sm:text-5xl font-extrabold text-white leading-tight mb-4">
            انضم إلى فريقنا
            <span className="block bg-gradient-to-l from-teal-300 to-blue-400 bg-clip-text text-transparent">
              خبير سوشال ميديا
            </span>
          </h1>

          <p className="text-gray-300 text-base sm:text-lg leading-relaxed max-w-xl">
            نبحث عن شخص مبدع في إدارة حسابات التواصل الاجتماعي وصناعة المحتوى.
            املأ النموذج التالي وسنراجع طلبك ونتواصل معك.
          </p>

          <div className="flex flex-wrap gap-2 mt-7">
            {['لا يستغرق أكثر من دقيقتين', 'جميع المنصات', 'إجابات مختصرة'].map(chip => (
              <span key={chip} className="px-3 py-1.5 rounded-lg bg-white/5 border border-white/10 text-gray-300 text-xs">
                {chip}
              </span>
            ))}
          </div>
        </div>

        <svg className="absolute bottom-0 left-0 w-full text-gray-50" viewBox="0 0 1440 60" fill="currentColor" preserveAspectRatio="none">
          <path d="M0,32 C240,64 480,0 720,16 C960,32 1200,64 1440,40 L1440,60 L0,60 Z" />
        </svg>
      </header>

      {/* Progress */}
      <div className="sticky top-0 z-20 bg-white/85 backdrop-blur border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-2.5">
          <div className="flex items-center gap-3">
            <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-l from-teal-400 to-blue-600 rounded-full transition-all duration-500"
                style={{ width: `${progress}%` }}
              />
            </div>
            <span className="text-xs font-bold text-gray-500 tabular-nums w-10 text-left">{progress}%</span>
          </div>
        </div>
      </div>

      {/* Form */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <form onSubmit={handleSubmit} noValidate className="space-y-6">

          {/* 1. Basic info */}
          <SectionCard number={1} title="المعلومات الأساسية" subtitle="كيف يمكننا التواصل معك؟">
            <div data-error={!!errors.full_name}>
              <Field label="الاسم الكامل" htmlFor="full_name" required error={errors.full_name}>
                <input
                  id="full_name"
                  type="text"
                  value={form.full_name}
                  onChange={e => update('full_name', e.target.value)}
                  placeholder="مثال: أحمد عبدالله الفهد"
                  className={inputClasses(!!errors.full_name)}
                />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div data-error={!!errors.phone}>
                <Field
                  label="رقم الهاتف"
                  htmlFor="phone"
                  required
                  error={errors.phone}
                  hint="اختر رمز الدولة ثم أدخل الرقم بدونه"
                >
                  <div className="flex gap-2 items-stretch">
                    <SelectControl
                      value={form.country_code}
                      onChange={e => update('country_code', e.target.value)}
                      aria-label="رمز الدولة"
                      wrapperClassName="w-32 flex-shrink-0"
                      className="text-left font-semibold"
                      dir="ltr"
                    >
                      {COUNTRIES.map(c => (
                        <option key={c.code} value={c.code}>
                          {c.flag} {c.code}
                        </option>
                      ))}
                    </SelectControl>

                    <input
                      id="phone"
                      type="tel"
                      inputMode="numeric"
                      dir="ltr"
                      value={form.phone}
                      onChange={e => update('phone', e.target.value.replace(/\D/g, ''))}
                      placeholder={selectedCountry.placeholder}
                      maxLength={15}
                      className={`
                        flex-1 min-w-0 ${controlClasses(!!errors.phone)}
                        text-left text-lg font-semibold tracking-wide tabular-nums
                      `}
                    />
                  </div>
                </Field>
              </div>

              <div data-error={!!errors.email}>
                <Field label="البريد الإلكتروني" htmlFor="email" required error={errors.email}>
                  <input
                    id="email"
                    type="email"
                    dir="ltr"
                    value={form.email}
                    onChange={e => update('email', e.target.value)}
                    placeholder="name@example.com"
                    className={`${inputClasses(!!errors.email)} text-left`}
                  />
                </Field>
              </div>
            </div>

            <div data-error={!!errors.location}>
              <Field label="المدينة / الدولة" htmlFor="location" required error={errors.location}>
                <input
                  id="location"
                  type="text"
                  value={form.location}
                  onChange={e => update('location', e.target.value)}
                  placeholder="مثال: الكويت، الكويت"
                  className={inputClasses(!!errors.location)}
                />
              </Field>
            </div>
          </SectionCard>

          {/* 2. Experience */}
          <SectionCard number={2} title="الخبرة" subtitle="حدثنا عن خبرتك في إدارة السوشال ميديا">
            <div data-error={!!errors.has_experience}>
              <Field label="هل سبق لك العمل في إدارة السوشال ميديا؟" required error={errors.has_experience}>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { value: 'yes' as const, label: 'نعم' },
                    { value: 'no' as const, label: 'لا' }
                  ].map(opt => {
                    const active = form.has_experience === opt.value;
                    return (
                      <button
                        key={opt.value}
                        type="button"
                        onClick={() => update('has_experience', opt.value)}
                        className={`
                          flex items-center justify-center gap-2 px-4 py-3 rounded-xl border-2 font-semibold
                          transition-all duration-200
                          ${active
                            ? 'border-blue-600 bg-blue-50 text-blue-700 shadow-sm'
                            : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300'}
                        `}
                      >
                        <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${active ? 'border-blue-600' : 'border-gray-300'}`}>
                          {active && <span className="w-2 h-2 rounded-full bg-blue-600" />}
                        </span>
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </Field>
            </div>

            {form.has_experience === 'yes' && (
              <div className="space-y-5 animate-fadeIn">
                <div data-error={!!errors.years_experience}>
                  <Field label="كم سنة خبرة لديك؟" htmlFor="years_experience" required error={errors.years_experience}>
                    <SelectControl
                      id="years_experience"
                      value={form.years_experience}
                      onChange={e => update('years_experience', e.target.value)}
                      hasError={!!errors.years_experience}
                    >
                      <option value="">اختر المدة</option>
                      {YEARS_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </SelectControl>
                  </Field>
                </div>

                <div data-error={!!errors.account_links}>
                  <Field
                    label="أفضل 3 حسابات أدرتها"
                    optional
                    error={errors.account_links}
                    hint="رابط أو اسم الحساب — مثال: @username أو instagram.com/username"
                  >
                    <div className="space-y-2.5">
                      {form.account_links.map((link, i) => (
                        <div key={i} className="relative">
                          <span className="absolute inset-y-0 right-3 flex items-center text-xs font-bold text-gray-300">
                            {i + 1}
                          </span>
                          <input
                            type="text"
                            value={link}
                            onChange={e => updateLink(i, e.target.value)}
                            placeholder="@username"
                            className={`${inputClasses()} pr-9`}
                          />
                        </div>
                      ))}
                    </div>
                  </Field>
                </div>
              </div>
            )}

            <div data-error={!!errors.platforms}>
              <Field label="ما المنصات التي لديك خبرة فيها؟" required error={errors.platforms} hint="يمكنك اختيار أكثر من منصة">
                <div className="grid grid-cols-2 gap-3">
                  {PLATFORMS.map(platform => {
                    const active = form.platforms.includes(platform.id);
                    return (
                      <button
                        key={platform.id}
                        type="button"
                        onClick={() => togglePlatform(platform.id)}
                        aria-pressed={active}
                        className={`
                          group relative flex items-center gap-3 px-3 sm:px-4 py-3 rounded-xl border-2 text-right
                          transition-all duration-200
                          ${active
                            ? 'border-blue-600 bg-blue-50/60 shadow-sm'
                            : 'border-gray-200 bg-white hover:border-gray-300'}
                        `}
                      >
                        <span className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center shadow-sm ${platform.tile}`}>
                          <svg className={`w-5 h-5 ${platform.icon}`} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d={BRAND_PATHS[platform.id]} />
                          </svg>
                        </span>
                        <span className={`text-sm font-semibold truncate ${active ? 'text-blue-800' : 'text-gray-700'}`}>
                          {platform.name}
                        </span>
                        <span
                          className={`
                            absolute top-2 left-2 w-4 h-4 rounded-md flex items-center justify-center transition-all
                            ${active ? 'bg-blue-600' : 'bg-transparent border border-gray-200'}
                          `}
                        >
                          {active && (
                            <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </Field>
            </div>
          </SectionCard>

          {/* 3. Availability */}
          <SectionCard number={3} title="التوفر" subtitle="آخر خطوة قبل إرسال الطلب">
            <div data-error={!!errors.availability}>
              <Field label="متى يمكنك البدء؟" htmlFor="availability" required error={errors.availability}>
                <SelectControl
                  id="availability"
                  value={form.availability}
                  onChange={e => update('availability', e.target.value)}
                  hasError={!!errors.availability}
                >
                  <option value="">اختر الوقت المناسب</option>
                  {AVAILABILITY_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </SelectControl>
              </Field>
            </div>

            {form.availability === 'specific_date' && (
              <div className="animate-fadeIn" data-error={!!errors.start_date}>
                <Field label="حدد التاريخ" htmlFor="start_date" required error={errors.start_date}>
                  <input
                    id="start_date"
                    type="date"
                    value={form.start_date}
                    onChange={e => update('start_date', e.target.value)}
                    className={`${inputClasses(!!errors.start_date)} text-left`}
                  />
                </Field>
              </div>
            )}

          </SectionCard>

          {submitError && (
            <div className="flex items-start gap-3 p-4 rounded-xl bg-red-50 border border-red-100 text-red-700">
              <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 9a1 1 0 012 0v4a1 1 0 11-2 0V9zm1-4a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
              </svg>
              <div className="text-sm">
                <p className="font-semibold">{submitError}</p>
                {serverErrorList.length > 0 && (
                  <ul className="mt-2 space-y-1 list-disc pr-4 marker:text-red-400">
                    {serverErrorList.map((message, i) => (
                      <li key={i}>{message}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}

          {/* Submit */}
          <div className="pt-2 pb-4">
            <button
              type="submit"
              disabled={submitting}
              className={`
                w-full flex items-center justify-center gap-2 px-8 py-4 rounded-2xl
                text-white font-bold text-base sm:text-lg
                bg-gradient-to-l from-teal-500 to-blue-600
                shadow-lg shadow-blue-600/20
                transition-all duration-200
                ${submitting ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-xl hover:shadow-blue-600/30 active:scale-[0.99]'}
              `}
            >
              {submitting ? (
                <>
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  <span>جاري الإرسال...</span>
                </>
              ) : (
                <>
                  إرسال الطلب
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 19l-7-7 7-7M4 12h16" />
                  </svg>
                </>
              )}
            </button>
            <p className="text-center text-xs text-gray-400 mt-4">
              بإرسال الطلب فإنك توافق على تواصل فريق Kuwait Best Solver معك بخصوص طلبك.
            </p>
          </div>
        </form>
      </main>

      <footer className="border-t border-gray-100 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 flex flex-col items-center gap-3">
          <img src={LOGO} alt="Kuwait Best Solver" className="h-10 w-auto object-contain opacity-80" />
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Kuwait Best Solver. جميع الحقوق محفوظة.
          </p>
        </div>
      </footer>
    </div>
  );
};
